import { createApp } from "@mzhub/plexus";
import Layout from "./components/layout/Layout";
import "./styles.css";

createApp({ Layout });
